import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import ParallelButtonSelection from '../../../components/selections/periodSelection/parallelButtonSelection';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import DropdownPicker from '../../../components/pickers/dropdownPicker';
import { ThemeContext } from '../../../context/theme-context';
import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './FinancialStatement.scss';
import { useDispatch, useSelector } from "react-redux";
import { FinancialsServiceApi } from "../../../services/stockAnalysis/api";
import { Configuration } from "../../../services/stockAnalysis/configuration";
import lodash, { findIndex, set } from 'lodash';
import { QuarterServiceApi, CurrencyServiceApi } from "../../../services/actionHub/api";
import { Configuration as ActionHubServiceApiConfiguration } from "../../../services/actionHub/configuration"
import NumberFormatter from '../../../formatters/NumberFormatter';
import { Button } from 'primereact/button';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
import de from 'date-fns/esm/locale/de/index.js';
import { faChevronsDown, faChevronsUp } from '@fortawesome/pro-duotone-svg-icons';

const FinancialStatement = () => {
    const { t, i18n } = useTranslation();
    const financialsServiceApi = new FinancialsServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH));
    const quarterServiceApi = new QuarterServiceApi(new ActionHubServiceApiConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const currencyServiceApi = new CurrencyServiceApi(new ActionHubServiceApiConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const numberFormatter = new NumberFormatter();
    const token = useSelector((state) => state.auth?.token);
    const selectedSecuriy = useSelector((state) => state.security?.selectedSecurity);
    const toast = useRef(null);
    const [theme, setTheme] = useState('dark'); // ['dark', 'light'
    const currentTheme = useContext(ThemeContext).theme;
    const [activeTitle, setActiveTitle] = useState(null);
    const [activeTitleName, setActiveTitleName] = useState('Bilanço');
    const [expandedRows, setExpandedRows] = useState(null);
    const [isShowDetail, setIsShowDetail] = useState(false);
    const [mainTableData, setMainTableData] = useState([]);
    const [quarters, setQuarters] = useState([]);
    const [selectedQuarters, setSelectedQuarters] = useState([]);
    const [selectedQuarter1, setSelectedQuarter1] = useState([]);
    const [selectedQuarter2, setSelectedQuarter2] = useState([]);
    const [selectedQuarter3, setSelectedQuarter3] = useState([]);
    const [selectedQuarter4, setSelectedQuarter4] = useState([]);
    const [selectedQuarter5, setSelectedQuarter5] = useState([]);
    const [tableData, setTableData] = useState([]); // Filtrelenmiş veri seti
    const [currency, setCurrency] = useState();
    const [selectedCurrencyIndex, setSelectedCurrencyIndex] = useState();
    const language = i18n.language;

    const [data, setData] = useState([]);
    // const [tableData, setTableData] = useState([]);
    const [groupTitles, setGroupTitles] = useState([]);
    // const [activeTitle, setActiveTitle] = useState(1);
    // const [expandedRows, setExpandedRows] = useState(null);

    const columnStyle = { width: '16.66%' };
    // const groupTitles =
    //     [
    //         {
    //             id: 1,
    //             name: "Bilanço",
    //         },
    //         {
    //             id: 2,
    //             name: "Gelir Tablosu",

    //         },
    //         {
    //             id: 3,
    //             name: "Nakit Akım",
    //         },
    //     ]

    const currencyComboData = [
        {
            id: 0,
            name: t('currency.turkishLira'),
        },
        {
            id: 1,
            name: t('currency.uSDollar'),
        },
        {
            id: 2,
            name: t('currency.euro'),
        },
    ];

    useEffect(() => {
        if (theme !== currentTheme)
            setTheme(currentTheme);
    }, [theme]);

    useEffect(() => {
        if (selectedSecuriy.id !== null && selectedSecuriy.id !== undefined && selectedCurrencyIndex && selectedCurrencyIndex.id !== null && selectedCurrencyIndex.id !== undefined) {
            getFinancialData();
            getQuarter();
            // setExpandedRows({
            //     "Bilanço": true,
            //     "Gelir Tablosu": true,
            //     "Nakit Akım": true
            // })
        }
    }, [selectedSecuriy, selectedCurrencyIndex]);

    useEffect(() => {
        if (mainTableData.length > 0) {
            // clickTitle(groupTitles[0]);
        }

    }, [mainTableData]);

    useEffect(() => {
        getCurrencies();
    }, []);

    useEffect(() => {
        updateTableData();
    }, [activeTitle, groupTitles]);


    //#region ParallelButtonSelection
    const clickTitle = (title) => {

        setActiveTitle(title.id);
        setActiveTitleName(title.name);
        // Seçilen groupLine'ın altındaki item'ları bul
        const items = mainTableData.length > 0 ? mainTableData.flatMap(row => [row, ...(row.details || [])]) : [];
        // Tüm orijinal item'ları bulmak için API'den gelen veriyi saklaman gerekebilir, burada mainTableData'dan yola çıkıyoruz
        let filtered = [];
        let found = false;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.caption && item.caption.isGroupLine && item.caption.name === title.name) {
                found = true;
                continue;
            }
            if (found) {
                if (item.caption && item.caption.isGroupLine) {
                    break;
                }
                filtered.push(item);
            }
        }
        setTableData(filtered);
        
    };
    //#endregion ParallelButtonSelection

    //#region  DropdownPicker
    const onCurrencyListChange = (e) => {
        // console.log('onCurrencyListChange', e);
        // setSelectedIndex(e.value);
        try {
            let index = findIndex(currency, { id: e.id });
            setSelectedCurrencyIndex(currency[index]);
        } catch (error) {
            console.log(error);
        }
    }

    //#endregion  DropdownPicker


    //#region API CALLS

    //#region FINANCIALDATA



    const getFinancialData = () => {
        let identityToken = token;
        let entityId = "";
        const culture = language;
        if (!selectedSecuriy || !selectedSecuriy.id) {
            console.error('Selected security is not valid');
            return;
        }
        entityId = selectedSecuriy.id;

        financialsServiceApi.stockanalysisFinancialsGet(token, culture, entityId, selectedCurrencyIndex.id).then((res) => {
            // Helper to build nested hierarchy based on levels recursively
            const buildSubtree = (items, startIdx, parentLevel) => {
                const nodes = [];
                let i = startIdx;
                while (i < items.length && items[i].caption.level > parentLevel) {
                    const current = items[i];
                    const node = { ...current, details: [] };
                    i++;
                    // Recursively attach children deeper than current level
                    while (i < items.length && items[i].caption.level > current.caption.level) {
                        const [children, newI] = buildSubtree(items, i, current.caption.level);
                        node.details.push(...children);
                        i = newI;
                    }
                    nodes.push(node);
                }
                return [nodes, i];
            };

            // Process items for a group: flatten into proper parent-child based on levels and headlines
            const processGroupItems = (items) => {
                const result = [];
                let i = 0;
                while (i < items.length) {
                    const item = items[i];
                    if (item.caption.level <= 0) {
                        result.push({ ...item, details: [] });
                        i++;
                        continue;
                    }

                    const isHeadlineOrLevel1 = item.caption.isHeadline === true || item.caption.level === 1;
                    const node = { ...item, details: [] };
                    i++;
                    while (i < items.length && items[i].caption.level > item.caption.level) {
                        const [children, newI] = buildSubtree(items, i, item.caption.level);
                        node.details.push(...children);
                        i = newI;
                    }
                    result.push(node);
                }
                return result;
            };

            const groupTitles = [];
            const groupedData = {};

            // Identify group headers and initialize their containers
            res.data.items.filter(item => item.caption.isGroupLine).forEach(item => {
                const groupName = item.caption.name;
                groupTitles.push({ id: groupTitles.length + 1, name: groupName });
                groupedData[groupName] = { ...item, details: [] };
            });

            // For each group, collect its slice and build hierarchy using recursive functions
            for (const title of groupTitles) {
                const groupName = title.name;
                const startIdx = res.data.items.findIndex(item => item.caption.isGroupLine && item.caption.name === groupName);
                let endIdx = res.data.items.findIndex((item, idx) => idx > startIdx && item.caption.isGroupLine);
                if (endIdx === -1) endIdx = res.data.items.length;
                const groupItems = res.data.items.slice(startIdx + 1, endIdx);

                // Process the group's items into hierarchical structure
                const processedDetails = processGroupItems(groupItems);
                groupedData[groupName].details = processedDetails;
            }

            setData(groupedData);
            setGroupTitles(groupTitles);
            setActiveTitle(1); // İlk başlık varsayılan olarak seçili

            console.log('groupedData: ', groupedData);
            console.log('groupTitles: ', groupTitles);
        }).catch((err) => {
            console.error(err);
        });
    };




    const updateTableData = () => {
        const activeGroupName = groupTitles.find(title => title.id === activeTitle)?.name;
        if (activeGroupName) {
            const tableDetails = data[activeGroupName]?.details || [];
            setTableData(tableDetails);
            console.log('Updated tableData:', tableDetails);

            // Debug: Kontrol et - Level 2 öğelerinin details dizisi var mı ve içinde level 3 öğeleri var mı
            tableDetails.forEach(item => {
                if (item.caption.level === 1 || item.caption.level === 2) {
                    console.log(`Level ${item.caption.level} item: ${item.caption.name}, has details:`,
                        item.details && item.details.length > 0,
                        'details count:', item.details ? item.details.length : 0);
                }
            });
        }
    };
    //#endregion FINANCIALDATA


    const getQuarter = () => {
        let identityToken = token;
        let entityId = "sec.101.368";
        const culture = language;
        entityId = selectedSecuriy.id;
        quarterServiceApi.actionhubQuarterGet(token, entityId).then((res) => {
            const updatedQuartersData = res.data.quarters.map(item => {
                const nameStr = item.toString();

                return {
                    DisplayName: `${nameStr.substring(0, 4)}/${nameStr.substring(4)}`,
                    Name: item,
                    Id: item
                };
            });

            setQuarters(updatedQuartersData);
            // İlk 5 quarters değerini varsayılan olarak seçili yap
            const initialSelectedQuarters = updatedQuartersData.slice(0, 5).map(q => q.Name);
            setSelectedQuarters(initialSelectedQuarters);

            setSelectedQuarter1(updatedQuartersData[0]);
            setSelectedQuarter2(updatedQuartersData[1]);
            setSelectedQuarter3(updatedQuartersData[2]);
            setSelectedQuarter4(updatedQuartersData[3]);
            setSelectedQuarter5(updatedQuartersData[4]);
        }).catch((err) => {
            console.error(err);
        });
    };

    const formatCurrencyDisplayName = (name) => {
        if (!name) return name;
        const suffix = language === 'en-US' ? 'Million' : 'Milyon';
        return `${name} (${suffix})`;
    };

    const getCurrencies = () => {
        const culture = language;

        currencyServiceApi.actionhubCurrenciesGet(token, culture).then((res) => {
            console.log('actionhubCurrenciesGet: ' + res);
            const processedCurrencies = (res.data.items || []).map((item) => ({
                ...item,
                displayName: formatCurrencyDisplayName(item.name)
            }));
            setCurrency(processedCurrencies);
            setSelectedCurrencyIndex(processedCurrencies[0]);
        }).catch((err) => {
            console.log('actionhubCurrenciesGet: ' + err);
        });

    }



    //#endregion API sCALLS

    //#region DataTable
    // const allowExpansion = (rowData) => {
    //     
    //     return rowData.caption.isGroupLine;
    //     // return rowData.level == 1;
    // };
    const allowExpansion = (rowData) => {
        // Temel kontroller - rowData ve caption var mı?
        if (!rowData || !rowData.caption) {
            return false;
        }

        // En basit haliyle - details array varsa ve boş değilse expander göster
        return rowData.details && Array.isArray(rowData.details) && rowData.details.length > 0;
    };
    const expandAll = () => {
        // Genişletilebilir satırları bul
        const expandableDataKeys = tableData.reduce((acc, data) => {
            // Genişletilebilir olanları ekle
            if (allowExpansion(data)) {
                acc[data.caption.name] = true;
            }
            return acc;
        }, {});
        setExpandedRows(expandableDataKeys);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const clickShowDetails = () => {
        setIsShowDetail(!isShowDetail);

        if (!isShowDetail) {
            expandAll();
        }
        else {
            collapseAll();
        }
    }

    // Dropdown seçimlerini güncelleme fonksiyonları
    const onQuarterChange = (index, newValue, item) => {
        const newSelectedQuarters = [...selectedQuarters];
        newSelectedQuarters[index] = newValue;
        setSelectedQuarters(newSelectedQuarters); // Tüm quarterları güncelle

        if (index === 0) setSelectedQuarter1(item);
        if (index === 1) setSelectedQuarter2(item);
        if (index === 2) setSelectedQuarter3(item);
        if (index === 3) setSelectedQuarter4(item);
        if (index === 4) setSelectedQuarter5(item);
    };



    //#region subTable     // Alt tablo için bir body template fonksiyonu

    const nameBodyTemplate = (rowData) => {
        // Apply indentation via CSS class
        const nameLines = String(rowData.caption.name).split(/\r?\n/);
        const renderedName = nameLines.map((line, idx) => (
            <span key={idx}>{line}{idx < nameLines.length - 1 ? <br /> : null}</span>
        ));

        // Set CSS class for level and collapse
        let classNames = '';
        const isInMainTable = !rowData.isInRowExpansion; // Ana tablo veya alt tablo kontrolü

        if (isInMainTable && rowData.caption.style === 1) {
            classNames = 'mainTable-title';

            // Level 1 ve expandable olan satırlar için level-collapse ekle
            if (rowData.caption.level === 1 && allowExpansion(rowData)) {
                classNames += ' level-1 level-collapse';
            }
            // Level 2 satırları için level-collapse ekle 
            // (expander-sub'dan sonra gelen level 2 için)
            else if (rowData.caption.level === 2) {
                classNames += ' level-2 level-collapse';
            } else {
                classNames += ` level-${rowData.caption.level}`;
            }

            classNames += ' style-1';
            return (
                <div className={classNames} style={{ marginTop: '5px', marginBottom: '5px', fontWeight: 'bold' }}>
                    {renderedName}
                </div>
            );
        } else {
            // Eğer collapse (row expansion) içindeyse subTable-title, değilse free-title
            if (rowData.isInRowExpansion) {
                classNames = 'subTable-title';
            } else {
                classNames = 'free-title';
            }

            // Alt tablodaki tüm level'ler için doğru sınıfları ekle
            if (rowData.caption.level === 2) {
                classNames += ` level-${rowData.caption.level}`;
            } else if (rowData.caption.level >= 3) {
                // Level 3 ve üzeri için doğru indentation
                classNames += ` level-${Math.min(rowData.caption.level, 5)}`;
            } else {
                classNames += ` level-${rowData.caption.level}`;
            }

            // style===1 olan öğeler için style-1 sınıfını ekle (hem ana tabloda hem de collapse içinde)
            if (rowData.caption.style === 1) {
                classNames += ' style-1';
            }

            return (
                <div className={classNames}>
                    {renderedName}
                </div>
            );
        }
    };

    // Level 2 ve 3'ü düzleştirilmiş olarak göstermek için artık iç içe DataTable'lara gerek yok

    // Tüm alt öğeleri düzleştiren yardımcı fonksiyon
    const flattenHierarchy = (items) => {
        const flattenedItems = [];

        // Özyinelemeli olarak tüm seviye elemanlarını düzleştir, parent bilgisi tut
        const processItem = (item, parent = null) => {
            // İtem'a isInRowExpansion ve parent bilgisi ekle
            const itemWithFlag = { ...item, isInRowExpansion: true, parent: parent ? parent.caption.name : null };
            flattenedItems.push(itemWithFlag);

            if (item.details && Array.isArray(item.details) && item.details.length > 0) {
                item.details.forEach(childItem => {
                    processItem(childItem, item);
                });
            }
        };

        // Tüm öğeleri işle, root öğelerin parent'ı null
        if (items && Array.isArray(items)) {
            items.forEach(item => processItem(item, null));
        }

        return flattenedItems;
    };

    // Ana DataTable için rowExpansionTemplate
    const rowExpansionTemplate = (rowData) => {
        console.log('Main rowExpansionTemplate called with rowData:', rowData);

        // Tüm seviyelerdeki öğeleri (Level 2, 3, 4, ...) düzleştir
        const allItems = flattenHierarchy(rowData.details);

        console.log('Flattened items for display:', allItems);

        const dynamicColumns = selectedQuarters.map((selectedQuarter, index) => ({
            header: selectedQuarter,

            body: (detailRowData) => {
                let value = detailRowData.values.find(val => val.quarter === selectedQuarter);
                return (
                    <>
                        {value && value.value < 0 &&
                            <div className='subTable-value-text negative'>
                                {value ? numberFormatter.Double(value.value, 0) : ''}
                            </div>
                        }

                        {value && value.value >= 0 &&
                            <div className='subTable-value-text positive'>
                                {value ? numberFormatter.Double(value.value, 0) : ''}
                            </div>
                        }
                    </>
                )
            }
        }));

        // Düzleştirilmiş listeyi göster - Level 2 ve Level 3 tek tabloda
        return (
            <div className='subTable'>
                <DataTable
                    className=''
                    value={allItems}
                    dataKey="caption.name"
                    tableStyle={{ minWidth: '50rem' }}
                    scrollHeight={'800px'}
                    scrollable>

                    <Column field="caption.name" body={nameBodyTemplate} header="" style={{ textAlign: 'left' }} headerStyle={{ textAlign: 'left' }} />
                    {dynamicColumns.map((col, index) => (
                        <Column key={index} header={col.header} body={col.body} style={{ width: '14%', textAlign: 'right' }} headerStyle={{ textAlign: 'left' }} />
                    ))}
                </DataTable>
            </div>
        );
    };
    // const rowExpansionTemplate = (data) => {
    //     return (
    //         <div>
    //             <DataTable value={data.details}>
    //                 <Column field="caption.name" header="Name" />
    //                 {data.details[0]?.values.map((_, index) => (
    //                     <Column key={index} field={`value${index}`} header={`Quarter ${index + 1}`} body={(rowData) => rowData.values[index]?.value || '-'} />
    //                 ))}
    //             </DataTable>
    //         </div>
    //     );
    // };

    //#endregion subTable



    // Dropdown  bodyTemplate fonksiyonu
    const bodyTemplate = (quarterIndex) => {


        if (quarterIndex == 'quarter1') {

            return (

                <Container>
                    <Row>
                        <Col md='12' className='quarter-select'>
                            <DropdownPicker
                                className=''
                                listData={quarters}
                                selectedListItem={selectedQuarter1}
                                onListItemChange={(event) => onQuarterChange(0, event.Name, event)}
                                optionLabel='DisplayName'
                                icon={true} />
                        </Col>
                    </Row>
                </Container>
                // <div className="flex align-items-center">
                //     <DropdownPicker
                //         className=''
                //         listData={quarters}
                //         selectedListItem={selectedQuarter1}
                //         onListItemChange={(event) => onQuarterChange(0, event.Name, event)}
                //         optionLabel='DisplayName'
                //         icon={true} />
                // </div>
            );
        }

        else if (quarterIndex == 'quarter2') {
            return (
                <Container>
                    <Row>
                        <Col md='12' className='quarter-select'>
                            <DropdownPicker
                                className=''
                                listData={quarters}
                                selectedListItem={selectedQuarter2}
                                onListItemChange={(event) => onQuarterChange(1, event.Name, event)}
                                optionLabel='DisplayName'
                                icon={true} />
                        </Col>
                    </Row>
                </Container>
            );
        }

        else if (quarterIndex == 'quarter3') {
            return (
                <Container>
                    <Row>
                        <Col md='12' className='quarter-select'>
                            <DropdownPicker
                                className=''
                                listData={quarters}
                                selectedListItem={selectedQuarter3}
                                onListItemChange={(event) => onQuarterChange(2, event.Name, event)}
                                optionLabel='DisplayName'
                                icon={true} />
                        </Col>
                    </Row>
                </Container>
            );
        }

        else if (quarterIndex == 'quarter4') {
            return (
                <Container>
                    <Row>
                        <Col md='12' className='quarter-select'>
                            <DropdownPicker
                                className=''
                                listData={quarters}
                                selectedListItem={selectedQuarter4}
                                onListItemChange={(event) => onQuarterChange(3, event.Name, event)}
                                optionLabel='DisplayName'
                                icon={true} />
                        </Col>
                    </Row>
                </Container>
            );
        }

        else if (quarterIndex == 'quarter5') {
            return (
                <Container>
                    <Row>
                        <Col md='12' className='quarter-select'>
                            <DropdownPicker
                                className=''
                                listData={quarters}
                                selectedListItem={selectedQuarter5}
                                onListItemChange={(event) => onQuarterChange(4, event.Name, event)}
                                optionLabel='DisplayName'
                                icon={true} />
                        </Col>
                    </Row>
                </Container>
            );
        }
    };

    const currencySelectHeaderTemplate = () => {
        return (

            <Container>
                <Row>
                    <Col md='12' className='currecy-select'>
                        <DropdownPicker placeholder="" className='' listData={currency} selectedListItem={selectedCurrencyIndex} onListItemChange={onCurrencyListChange} icon={true} optionLabel='displayName' />
                    </Col>
                </Row>
            </Container>

        )
    }

    const mainTableQuarterValueTemplate = (rowData, column) => {
        let value = rowData.values.find(val => val.quarter === column.props.header);
        return (
            <>
                {value && value.value < 0 &&
                    <div className='mainTable-value-text negative'>
                        {value ? numberFormatter.Double(value.value, 0) : ''}
                    </div>
                }

                {value && value.value >= 0 &&
                    <div className='mainTable-value-text positive'>
                        {value ? numberFormatter.Double(value.value, 0) : ''}
                    </div>
                }
            </>
        );
    };

    //#endregion DataTable
    // Artık allowExpansion2'ye gerek yok, tek bir allowExpansion fonksiyonu kullanıyoruz
    return (
        <div className='financial-statement'>

            <Toast ref={toast} />

            <Container className='table-up-container'>
                <Row className='p-0'>
                    <Col className='p-0'>

                        <ParallelButtonSelection titles={groupTitles} activeTitle={activeTitle} clickTitle={clickTitle} />
                    </Col>

                    <Col className='detail-col transition'>
                        <div className='detail-text text-align-right roboto-bold-16' onClick={clickShowDetails}>
                            <label className='show-detail transition'>

                                {!isShowDetail &&
                                    <div>
                                        {t('showDetail')}

                                        <FontAwesomeIcon icon={faChevronsDown} onClick={expandAll} className='detail-icon' />
                                    </div>
                                }

                                {isShowDetail &&
                                    <div>
                                        {t('restrictDetail')}

                                        <FontAwesomeIcon icon={faChevronsUp} onClick={collapseAll} className='detail-icon' />
                                    </div>
                                }
                            </label>
                        </div>
                    </Col>

                </Row>
            </Container>
            <div className="datatable-responsive">
                <DataTable
                    value={tableData}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    dataKey="caption.name"
                    tableStyle={{ minWidth: '50rem' }}
                    scrollHeight={'100%'}
                    scrollable
                >
                    <Column

                        className="expander-sub"
                        style={{ width: '2%', textAlign: 'left' }}
                        expander={allowExpansion}

                    />
                    <Column
                        field="caption.name"
                        header={currencySelectHeaderTemplate}
                        body={nameBodyTemplate}
                        style={{ width: '30%', textAlign: 'left', padding: 0 }}
                        headerStyle={{ textAlign: 'left', padding: 0 }}
                    />
                    {quarters.slice(0, 5).map((_, idx) => (
                        <Column
                            key={idx}
                            field=""
                            header={bodyTemplate(`quarter${idx + 1}`)}
                            body={(rowData) =>
                                mainTableQuarterValueTemplate(rowData, { props: { header: selectedQuarters[idx] } })
                            }
                            style={{ width: '14%', textAlign: 'right' }}
                            headerStyle={{ textAlign: 'right' }}
                        />
                    ))}
                </DataTable>
            </div>

        </div>
    );
}


export default FinancialStatement;
